<div class="dialog-container">
    <!-- <div
        style="position: relative; color: #20304F; font-size: 18px; font-family: Inter; font-weight: 600; word-wrap: break-word">
        Make Payment
        <span style="position: absolute;right:0;"> <i class="fa-solid fa-xmark" mat-dialog-close=false></i></span>
    </div>
    <div>
        Cadre/RP Name : {{data.message.member_name}} | Month : {{data.message.month}}
    </div>
    <div style="width: 100%; position: relative; outline: 1px #D7D7D7 solid; outline-offset: -0.50px;margin:0.5rem 0;">
    </div> -->
    <div>{{'doYouwantToApprovePayment' | translate}}</div>
    <mat-dialog-content>
        <!-- <div class="dialog-content-container">
            <div class="row">
                <div class="col">
                    <div class="dialog-content-net-amount-label"> Net Amount Payable (₹)</div>
                </div>
                <div class="col">
                    <div class="dialog-content-net-amount-txt-container">
                        <div class="dialog-content-net-amount-txt"> {{data.message.net_amount_payable}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="dialog-content-pay-amount"><span class="dialog-content-pay-amount-label">Pay Amount
                            (₹)</span><span class="dialog-content-pay-amount-required">*</span>
                    </div>
                </div>
                <div class="col">
                    <div class="dialog-content-pay-amount-container">
                        <div class="dialog-content-pay-amount-container-txt">
                            <form class="example-form">
                                <mat-form-field class="example-full-width" style="height: 30px !important;
                                min-height: 30px !important;
                                ">
                                    <input matInput [formControl]="payableAmountControl" type="number"
                                        style="text-align: right;padding:0 !important" class="no-scrollbar">
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="dialog-content-net-amount-label"> Due Amount(₹) : </div>
                </div>
                <div class="col">
                    <div class="dialog-content-net-amount-txt-container">
                        <div class="dialog-content-net-amount-txt" #dueAmount> {{data.message.previous_due_amount}}
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </mat-dialog-content>
    <!-- <p *ngIf="isWrongAmount" style="color: red;text-align: center;">Enter Correct Pay Amount</p> -->
    <mat-dialog-actions align="end">
        <!-- <button mat-button>Yes</button>
          -->


        <div class="dialog-action-container">
            <div mat-button class="dialog-action-buttons">
                <!-- <div [ngStyle]="isWrongAmount?{'pointer-events': 'none'} : {'pointer-events': 'auto'}"
                    class="dialog-action-button-yes" (click)="confirm()">
                    Pay</div> -->
                <div class="dialog-action-button-yes" (click)="confirm()">
                    {{'yes' | translate}}</div>
            </div>
            <div mat-button mat-dialog-close=false cdkFocusInitial class="dialog-action-buttons">
                <div class="dialog-action-button-cancel">
                    {{ 'cancel' | translate }}</div>
            </div>
        </div>

        <!-- <button mat-button mat-dialog-close="true" cdkFocusInitial>Cancel</button> -->
    </mat-dialog-actions>
</div>